'use client';

// Client-side view of the server-only kill switches in utils/feature-flags.ts.
// The root layout (a dynamic server component) reads MERCH_ENABLED / SUBSCRIPTIONS_ENABLED
// at request time and passes them here, so client components never read process.env
// (a non-NEXT_PUBLIC_ var is always undefined in the browser bundle).
// Default is everything OFF: a component rendered outside the provider hides the feature.
import React, { createContext, useContext } from 'react';

export interface SiteFlags {
  merchEnabled: boolean;
  hardcoverEnabled: boolean;
  extraCopies: boolean;
  comics: boolean;
  /** Comics can be ordered in print (COMIC_PRINT_ENABLED). */
  comicPrint: boolean;
  /** New 24-page square comics can be created (COMIC_SQUARE_ENABLED). */
  comicSquare: boolean;
  /** Comic previews are cover, title and logline only (COMIC_FAST_PREVIEW). */
  comicFastPreview: boolean;
  subscriptionsEnabled: boolean;
  fastPathWizard: boolean;
  fastPathWizardRollout: number;
  redoGuarantee: boolean;
}

const DEFAULT_FLAGS: SiteFlags = { merchEnabled: false, hardcoverEnabled: false, extraCopies: false, comics: false, comicPrint: false, comicSquare: false, comicFastPreview: false, subscriptionsEnabled: false, fastPathWizard: false, fastPathWizardRollout: 0, redoGuarantee: false };

const SiteFlagsContext = createContext<SiteFlags>(DEFAULT_FLAGS);

export function SiteFlagsProvider({ flags, children }: { flags: SiteFlags; children: React.ReactNode }) {
  return <SiteFlagsContext.Provider value={flags}>{children}</SiteFlagsContext.Provider>;
}

export function useSiteFlags(): SiteFlags {
  return useContext(SiteFlagsContext);
}
